import {ReactNode} from 'react';
import PropTypes from 'prop-types';
import {
    Navigate,
    useLocation
} from "react-router-dom";
import {PlatformLoader} from '@flexinet/ui-components';
import {useAuth} from "../hooks/useAuth.ts";

// FNP-1932: a route guard that can tell "not signed in" from "not known yet".
// It reads `status`, never `user`: `user` is undefined until getCurrentUser()
// answers, so a hard-loaded deep link used to redirect a signed-in operator
// home on its first render. Same shape as the console guard (FNP-1718).
export const RequireAuth = ({children}: { children: ReactNode }) => {
    const {status} = useAuth();
    const location = useLocation();

    if (status === 'resolving') {
        return <PlatformLoader message='Signing in...'/>;
    }

    if (status === 'anonymous') {
        return <Navigate to="/" replace state={{from: location}}/>;
    }

    return children;
};

RequireAuth.propTypes = {
    children: PropTypes.node,
};
